<template>
  <AuthWrapper>
    <NotFoundPage />
  </AuthWrapper>
</template>

<script>
import AuthWrapper from '../components/auth/AuthWrapper.vue';
import NotFoundPage from '../components/auth/NotFoundPage.vue';

export default {
  name: 'NotFoundPageView',
  components: {
    AuthWrapper,
    NotFoundPage
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style scoped>
/* Estilos específicos da view, se necessário */
</style>
